import { Injectable } from '@angular/core';
import { bank } from '../../interface/bank/bank';
import { HttpService } from '../http/http.service';
import { firstValueFrom } from 'rxjs';
import { toDateParam } from 'src/app/utils';

@Injectable({
  providedIn: 'root'
})
export class BankService {
// TODO: Remove the any from the return type 
  constructor(private _httpService:HttpService) { }
createAccount(data:bank){
  return this._httpService.post('/Banks',data).toPromise()

}
public async getAccountList():Promise<any>{
  return firstValueFrom(this._httpService.get('/Banks'));
}
public async depositTransaction(data):Promise<any>
{
  return firstValueFrom(this._httpService.post('/Banks/Transactions/Deposit', data))
}
public async withdrawTransaction(data):Promise<any>{
  return firstValueFrom(this._httpService.post('/Banks/Transactions/Withdraw', data))
}
public async get(id: number): Promise<any> {
  return firstValueFrom(this._httpService.get(`/Banks/${id}`));
}
public async getLedger(id: number, startDate?: string | Date, endDate?: string | Date): Promise<any> {
  const query = `?startDate=${toDateParam(startDate)}&endDate=${toDateParam(endDate)}`;
  return firstValueFrom(this._httpService.get(`/Banks/${id}/ledger${query}`));
}
public async update(id: number, data: bank): Promise<any> {
  return firstValueFrom(this._httpService.put('/Banks/', id, data));
}
}
